import { useEffect, useState } from "react";

const pad = (n) => String(Math.max(0, Math.floor(n))).padStart(2, "0");

/**
 * Live countdown to an ISO deadline string.
 * Returns { dd, hh, mm, ss, expired, ms }.
 * Always compared against Date.now(); the backend independently enforces
 * closure via /api/g-club/status.closed.
 */
export const useCountdown = (deadlineIso) => {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (!deadlineIso) return;
    const id = window.setInterval(() => setNow(Date.now()), 1000);
    return () => window.clearInterval(id);
  }, [deadlineIso]);

  if (!deadlineIso) {
    return { dd: "00", hh: "00", mm: "00", ss: "00", expired: false, ms: 0 };
  }
  const deadline = new Date(deadlineIso).getTime();
  const ms = deadline - now;
  const expired = ms <= 0;
  const secs = Math.max(0, ms / 1000);
  const dd = Math.floor(secs / 86400);
  const hh = Math.floor((secs % 86400) / 3600);
  const mm = Math.floor((secs % 3600) / 60);
  const ss = Math.floor(secs % 60);
  return {
    dd: pad(dd),
    hh: pad(hh),
    mm: pad(mm),
    ss: pad(ss),
    expired,
    ms,
  };
};

export default useCountdown;
